import React from 'react';
import cn from 'classnames';
import { ContentBlocks } from './ContentBlock';
import Color from 'color';
import { findByType } from '../utils';
import './SectionBlock.scss';
// eslint-disable-next-line complexity
export function SectionBlock({ data }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const id = (_a = findByType(data.value.config, 'id')) === null || _a === void 0 ? void 0 : _a.value;
    const textAlign = (_b = findByType(data.value.config, 'text_alignment')) === null || _b === void 0 ? void 0 : _b.value;
    const backgroundColor = (_c = findByType(data.value.config, 'background_color')) === null || _c === void 0 ? void 0 : _c.value;
    const padding = (_e = (_d = findByType(data.value.config, 'padding')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : 0;
    const paddingTop = (_f = findByType(data.value.config, 'padding_top')) === null || _f === void 0 ? void 0 : _f.value;
    const paddingBottom = (_g = findByType(data.value.config, 'padding_bottom')) === null || _g === void 0 ? void 0 : _g.value;
    const analytics = (_h = findByType(data.value.config, 'analytics_label')) === null || _h === void 0 ? void 0 : _h.value;
    const isDark = backgroundColor && Color(backgroundColor).isDark(); // eslint-disable-line new-cap
    return React.createElement("section", { id: id, className: cn('content-block-section', { 'dark-background': isDark }), "data-analytics-nav": analytics, style: { backgroundColor,
            '--padding-multiplier': padding,
            '--padding-top-multiplier': paddingTop,
            '--padding-bottom-multiplier': paddingBottom
        } },
        React.createElement("div", { className: "section-content", style: { textAlign } },
            React.createElement(ContentBlocks, { data: data.value.content })));
}
